import { render, staticRenderFns } from "./UserPlanActivationView.vue?vue&type=template&id=2f61ea9e"
import script from "./UserPlanActivationView.vue?vue&type=script&lang=js"
export * from "./UserPlanActivationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports